export class UserLogged {
    public id?: number;
    public email?: string;
    public image?: string;
    public role?: string;
    public logo?: string;
    public companyId?: number;
    public isTemporaryPassword?: boolean;
}
